<template>
  <div class="pal">
    <img
      style="width:1px; height:1px;"
      :src="'https://servedby.flashtalking.com/imp/2/112659;4077673;201;pixel;Forbes;PSGCDDSFLATRNNETNTVForbesForbesForbesmicrositemltnative/?cachebuster='+timecurr()"
    />
    <div class="container">
      <h1 class="name">Győrfi Pál</h1>
      <h2 class="subtitle">Az innováció iránti vonzalomról</h2>
      <div class="interju">interjú</div>
    </div>
    <div class="whtbg">
      <div class="container block">
        <div class="personpicbox">
          <img
            class="personpic"
            src="../assets/img/Gyorfi-Pal-cikk.jpg"
            alt="Győrfi Pál"
          />
          <img
            class="bluebox"
            src="../assets/img/blue-box.svg"
          />
        </div>
        <div class="coloredtitle">
          Négy gyerek apukájaként mit gondolsz, hogyan fognak ők élni?
        </div>
        <p>Annyira felgyorsult a világ, hogy nem tudhatjuk, húsz, tíz,
          vagy akár öt év múlva milyen képességekre, készségekre lesz
          szükség a sikerhez. A legnagyobb gyermekem már 22 éves, a diplomáját
          a kezében tartja, és várjuk, hogyan dönt a pályáját illetően.
          A többiek 5, 7, 9 évesek. Az ő jövőjük még rejtély, de az biztos,
          hogy két dolog, mégpedig az alkalmazkodóképesség és a lelki stabilitás
          erősítése, folyamatos fejlesztése a hasznukra válik majd.</p>
        <div class="anim bottom">
          <div class="coloredtitle">Beszélgetsz velük a környezettudatosságról?</div>
          <p>A változó világban a túlélési, boldogulási stratégiák is módosulnak.
            Ma még nem tudjuk, hogy milyen kihívások, környezeti veszélyek várnak majd rájuk.
            A klímaváltozásról szóló hírek, az erdőtüzek, állatfajok eltűnése, és így tovább,
            egyrészt megrémisztenek, másrészt viszont tenni akarással töltenek el.
            Az átlagember egyre jobban érzi a felelősséget az élhető világ fenntartásáért.</p>
        </div>
        <div class="clear"></div>
        <div class="anim bottom">
          <div class="coloredtitle">Te mit csinálsz, amivel próbálsz hatni a folyamatokra?</div>
          <p>Szelektíven gyűjtjük a hulladékot, nem szemetelünk. Megtanultuk, hogy mi,
            mennyi idő alatt bomlik le a természetben, ezek az adatok pedig hatottak
            a gyerekeink gondolkodására is. Nem kérünk nejlonzacskót a boltban,
            nem pazaroljuk a vizet, az áramot. Az alapstratégiát követem.</p>
        </div>
      </div>
      <div class="galleryblock">
        <img
          src="../assets/img/mercedes-eqc-page-gal-4.jpg"
          alt="Mercedes EQC interior"
        />
        <img
          src="../assets/img/mercedes-eqc-page-gal-5.jpg"
          alt="Mercedes EQC"
        />
        <img
          src="../assets/img/mercedes-eqc-page-gal-6.jpg"
          alt="Mercedes EQC interior"
        />
      </div>
      <div class="container block cols">
        <div class="colin">
          <div class="coloredtitle">Ezért használsz elektromos autót?</div>
          <p>Nálam két dolog szerencsésen találkozott: a környezettudatosság
            és az innováció iránti vonzalom. Mindig izgatott a jövő
            közlekedése is. A mentőknél a rohamkocsikat még nem tudjuk
            elektromosra cserélni, mert ott előre kiszámíthatatlan a feladat,
            és perceket sem lehet a töltésre várni, de a háttérmunkában már
            megjelentek a „zöld” autók. Egy fenntartható fejlődést,
            környezettudatosságot szolgáló kormányzati program keretében
            én is használatba vehettem egy tisztán elektromos hajtású autót,
            ráadásul szerencsémre ez egy Mercedes-Benz B-osztály Electric Drive, aminek külön
            is örülök, mivel kicsi gyerekkorom óta igazi Mercedes-Benz rajongó vagyok.
          </p>
          <div class="anim bottom">
            <div class="coloredtitle">Na de gyerekként biztosan nem az elektromosságot
              kötötted hozzá, hanem azt, hogy elegáns, nagy autó, valamiféle státusz
              szimbólum. Ehhez képest ez más.</div>
            <p>18 évesen kezdtem mentőzni. Akkoriban Nysa mentőautókkal jártunk,
              amit a népszerű Szomszédok tévésorozatban is gyakran lehetett látni.</p>
          </div>
        </div>
        <div class="colin anim bottom">
          <p>Emlékszem, amikor a 90-es évek elején beülhettem az első „nyugati” mentőautóba,
            és a sofőr méltatlankodni kezdett, amikor elfordította a kulcsot,
            hogy a vadiúj autó motorja nem indul. Aztán kiderült, hogy már régen,
            csöndben jár a motor, csak éppen mi a Nysa brummogó hangjára vártuk,
            mert ahhoz voltunk hozzászokva. Ilyen mértékű különbséget,
            technológiai ugrást éltem meg most az elektromos Mercedesnél is.
            Elképesztően hangtalan, ugyanakkor erős, dinamikus, és egyáltalán nem bocsát
            ki káros anyagokat. Nagyon jó, sőt különleges érzés ezt az autót használnom.
          </p>
          <div class="coloredtitle">Mert érezheted, hogy teszel valamit?</div>
          <p>Ez is benne van. Az elektromos autóval teszek valamit az élhető
            jövőért, vezetés közben pedig derűsebb, nyugodtabb vagyok. Nehéz megmagyarázni,
            de így csökken bennem a közlekedési stressz, és a fejlett technológia hatására
            egy ilyen autóban a vezető is valahogy tudatosabbá, precízebbé válik.
            Az ember úgy érzi, hogy megérkezett egy fejlettebb világba.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Pal',
  components: {},
  data() {
    return {};
  },
  methods: {
    animateBoxes() {
      const picbox = document.querySelectorAll('.personpicbox');
      window.addEventListener(
        'scroll',
        () => {
          for (let index = 0; index < picbox.length; index += 1) {
            const element = picbox[index];
            this.moveCalculator(element);
          }
        },
        { passive: true },
      );
      window.addEventListener('touchmove', () => {
        for (let index = 0; index < picbox.length; index += 1) {
          const element = picbox[index];
          this.moveCalculator(element);
        }
      });
    },
    moveCalculator(element) {
      const itemCenter = element.offsetTop + element.offsetHeight / 2;
      const scrollStart = window.pageYOffset + window.innerHeight / 10;
      const scrollEnd = window.pageYOffset + (window.innerHeight / 10) * 9;
      const scrollMid = scrollStart + (scrollEnd - scrollStart) / 2;
      const scrollRange = itemCenter - scrollMid;
      const distance = 0.15;

      if (itemCenter <= scrollMid) {
        element
          .querySelector('.personpic')
          .setAttribute(
            'style',
            `transform: translateY(${distance * scrollRange}px)`,
          );
        element
          .querySelector('.bluebox')
          .setAttribute(
            'style',
            `transform: translateY(${distance * scrollRange * -2}px)`,
          );
      }
      if (itemCenter > scrollMid) {
        element
          .querySelector('.personpic')
          .setAttribute(
            'style',
            `transform: translateY(${distance * scrollRange}px)`,
          );
        element
          .querySelector('.bluebox')
          .setAttribute(
            'style',
            `transform: translateY(${distance * scrollRange * -2}px)`,
          );
      }
    },
    isinviewElement(array) {
      for (let index = 0; index < array.length; index += 1) {
        const element = array[index];
        if (element.getBoundingClientRect().top < window.innerHeight
          && element.getBoundingClientRect().bottom > 0) {
          element.classList.add('active');
        } else {
          element.classList.remove('active');
        }
      }
    },
    isinviewScroll() {
      const anim = document.querySelectorAll('.anim');
      window.addEventListener('scroll', () => {
        this.isinviewElement(anim);
      }, { passive: true });
      window.addEventListener('touchmove', () => {
        this.isinviewElement(anim);
      });
      window.addEventListener('Load', () => {
        this.isinviewElement(anim);
      });
    },
    timecurr() {
      const time = new Date();
      return `${time.getFullYear()}${time.getMonth()}${time.getDate()}${time.getHours()}${time.getMinutes()}${time.getSeconds()}`;
    },
  },
  mounted() {
    this.animateBoxes();
    this.isinviewScroll();
  },
};
</script>
<style scoped lang="css">
.pal {
  padding-top: 60px;
}
.container.block {
  background-color: #fff;
  color: #151726;
  padding: 50px 60px;
  overflow: hidden;
}
.name {
  text-transform: uppercase;
  font-size: 18px;
  margin-block-start: 0;
  margin-block-end: 30px;
  font-weight: normal;
}
.subtitle {
  font-size: 77px;
  font-family: "Old Standard TT", serif;
  margin-block-start: 0;
  margin-block-end: 25px;
  font-weight: normal;
  line-height: 1;
}
.container {
  padding: 0 60px;
  width: calc(100% - 120px);
}
.interju {
  margin-bottom: 40px;
  color: #00adef;
  font-size: 18px;
}
.coloredtitle {
  color: #00adef;
  font-size: 21px;
  margin: 20px 0;
  line-height: 1.5;
}
.container p {
  font-size: 18px;
  line-height: 1.5;
}
.galleryblock {
  display: grid;
  display: -ms-grid;
  grid-template-columns: 1fr 1fr 1fr;
  -ms-grid-columns: 1fr 1fr 1fr;
}
.galleryblock img {
  width: 100%;
}
.galleryblock img:nth-child(1) {
  -ms-grid-column: 1;
}
.galleryblock img:nth-child(2) {
  -ms-grid-column: 2;
}
.galleryblock img:nth-child(3) {
  -ms-grid-column: 3;
}
.personpicbox {
  float: left;
  position: relative;
  overflow: hidden;
  display: -ms-flexbox;
}
.bluebox,
.personpic {
  width: 350px;
}
.bluebox {
  margin: 0 120px 40px 40px;
  z-index: 1;
  position: relative;
}
.personpic {
  position: absolute;
  left: 120px;
  bottom: -20px;
  z-index: 2;
}
.clear {
  clear: both;
  margin-top: 20px;
}
.cols {
  display: grid;
  display: -ms-grid;
  grid-template-columns: 1fr 1fr;
  -ms-grid-columns: 1fr 1fr;
}
.colin:nth-child(1) {
  padding-right: 30px;
  grid-column: 1/2;
  -ms-grid-column: 1;
}
.colin:nth-child(2) {
  padding-left: 30px;
  grid-column: 2/3;
  -ms-grid-column: 2;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.anim {
  overflow: hidden;
}
.anim.left {
  transform: translateX(-50%);
  transition: all 2s;
  opacity: 0;
}
.anim.left.active {
  transform: translateX(0%);
  opacity: 1;
}
.anim.right {
  transform: translateX(100%);
  transition: all 2s;
  opacity: 0;
}
.anim.right.active {
  transform: translateX(0%);
  opacity: 1;
}
.anim.top {
  transform: translateY(-50%);
  transition: all 2s;
  opacity: 0;
}
.anim.top.active {
  transform: translateY(0%);
  opacity: 1;
}
.anim.bottom {
  transform: translateY(100%);
  transition: all 2s;
  opacity: 0;
}
.anim.bottom.active {
  transform: translateY(0%);
  opacity: 1;
}
@media screen and (max-width: 767px) {
  .pal {
    padding-top: 30px;
  }
  .subtitle {
    font-size: 45px;
  }
  .container {
    padding: 0 30px;
    width: calc(100% - 60px);
  }
  .container.block {
    padding: 50px 30px;
  }
  .galleryblock {
    grid-template-columns: 1fr;
    -ms-grid-columns: 1fr;
  }
  .container.block.cols {
    padding: 50px 30px 20px 30px;
  }
  .cols {
    grid-template-columns: 1fr;
    -ms-grid-columns: 1fr;
  }
  .colin:nth-child(1) {
    padding-right: 0px;
    grid-column: 1/2;
    -ms-grid-column: 1;
  }
  .colin:nth-child(2) {
    padding-left: 0px;
    grid-column: 1/2;
    -ms-grid-column: 1;
  }
  .bluebox,
  .personpic {
    width: 250px;
  }
  .bluebox {
    margin: 0 80px 30px 0px;
  }
  .personpic {
    left: 45px;
    bottom: -10px;
  }
  .anim.left,
  .anim.right {
    transform: translateX(0%);
    opacity: 1;
  }
  .anim.top,
  .anim.bottom {
    transform: translateY(0%);
    opacity: 1;
  }
}
@media screen and (max-width: 640px) {
  .bluebox,
  .personpic {
    width: 200px;
  }
  .bluebox,
  .personpic {
    width: 200px;
  }
  .personpic {
    left: 30px;
  }
  .bluebox {
    margin: 0 55px 30px 0px;
  }
}
@media screen and (max-width: 540px) {
  .bluebox,
  .personpic {
    width: 160px;
  }
  .personpic {
    left: 20px;
  }
  .bluebox {
    margin: 0 50px 30px 0px;
  }
  .coloredtitle {
    font-size: 19px;
  }
  .subtitle {
    font-size: 40px;
  }
}
</style>
